<template>
  <div class="container">
    <q-page padding>
      <div class="row q-gutter-sm">
        <div class="col-xs-12 col-sm-8">
          <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
            Criar Origem Documento
          </p>
        </div>
      </div>
      <div class="row col-12 q-mt-lg">
        <q-btn
          label="Adicionar Origem"
          icon="add"
          no-caps
          color="primary"
          :outline="!rightDrawerModalOpen"
          @click="rightDrawerModalOpen = true"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <div class="row">
                <q-icon
                  style="cursor: pointer"
                  name="close"
                  class="q-mr-md"
                  size="22px"
                  @click="rightDrawerModalOpen = false"
                />
                <span style="font-size: 17px">
                  <span>
                    <span>Criar Origem</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="column no-wrap justify-between"
            style="width: 100%; height: 83%"
          >
            <div class="column col-12 no-wrap">
              <div class="q-px-md q-mt-sm text-weight-bold">
                <div>
                  <div>Nome Origem</div>
                  <q-input dense outlined v-model="dados.nomeOrigem" />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row q-mx-md">
                <p></p>
                <q-btn
                  label="Criar"
                  no-caps
                  color="positive"
                  dense
                  icon="check_circle_outline"
                  @click="criarOrigemDocumento()"
                />
              </div>
            </div>
          </div>
        </q-card>
      </Transition>
      <div class="q-mt-xl text-brand-5 text-weight-bold">
        <div style="font-size: 17px" class="q-mb-lg">
          Lista de Origens Criadas
        </div>
        <q-table
          :columns="columns"
          :rows="listaOrigemDocumentos"
          table-header-class="bg-accent text-weight-bold"
          class="tabela-tamanho-fixo"
          flat
          dense
          hide-bottom
          :rows-per-page-options="[0]"
        >
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                {{ props.row.nome }}
              </q-td>
              <q-td>
                <q-btn
                  icon="delete"
                  flat
                  color="red"
                  round
                  @click="excluirOrigemDocumento(props.row.nome)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </q-page>
    <div
      v-if="rightDrawerModalOpen"
      @click="rightDrawerModalOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let rightDrawerModalOpen = ref(false);
    const dados = ref({
      nomeOrigem: "",
    });
    const listaOrigemDocumentos = ref([]);

    const listarOrigemDocumento = async () => {
      listaOrigemDocumentos.value = [];
      try {
        const response = await store.dispatch(
          "documento/listarOrigemDocumento"
        );
        const array = response.data.resultado.message;
        if (array.length > 0) {
          array.forEach((value) => {
            listaOrigemDocumentos.value.push({ nome: value });
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const criarOrigemDocumento = async () => {
      if (dados.value.nomeOrigem == "") {
        quasar.notify({
          message: "Preencha o campo nome origem.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("documento/criarOrigemDocumento", {
          nomeOrigem: dados.value.nomeOrigem,
        });
        quasar.notify({
          message: "Origem do documento criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerModalOpen.value = false;
        listarOrigemDocumento();
      } catch (error) {
        quasar.notify({
          message: error.response.data.erro.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirOrigemDocumento = async (nome) => {
      try {
        await store.dispatch("documento/deletarOrigemDocumento", {
          nomeOrigem: nome,
        });
        quasar.notify({
          message: "Origem do documento excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarOrigemDocumento();
      } catch (error) {
        if (error.response.data.erro.trace[0]?.args[0]?.message) {
          quasar.notify({
            message: error.response.data.erro.trace[0]?.args[0]?.message,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } else {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    onMounted(listarOrigemDocumento);

    return {
      columns,
      rightDrawerModalOpen,
      dados,
      criarOrigemDocumento,
      listarOrigemDocumento,
      listaOrigemDocumentos,
      excluirOrigemDocumento,
    };
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
@media (max-width: 1400px) {
  .drawer-modal {
    max-height: 80%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
